import { render, staticRenderFns } from "./UserSettingsDataPush.vue?vue&type=template&id=3dca11c3&scoped=true"
import script from "./UserSettingsDataPush.vue?vue&type=script&lang=js"
export * from "./UserSettingsDataPush.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsDataPush.vue?vue&type=style&index=0&id=3dca11c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca11c3",
  null
  
)

export default component.exports